import React, { useCallback } from 'react'
import type { NavigateFunction } from 'react-router'
import { useLocation, useNavigate } from 'react-router-dom'

export function useQuery() {
  const { search } = useLocation()

  return React.useMemo(() => new URLSearchParams(search), [search])
}

export const GTM_PARAM_PREFIXES = ['_gl', '_ga', '_gcl_aw', '_gcl_dc', '_gcl_au'] as const

export function appendGTMParams(path: string, search: string): string {
  const params = new URLSearchParams(search)
  const gtmParams = new URLSearchParams()

  params.forEach((value, key) => {
    if (GTM_PARAM_PREFIXES.some(prefix => key.startsWith(prefix))) {
      gtmParams.set(key, value)
    }
  })

  const gtmString = gtmParams.toString()
  if (!gtmString) return path

  const separator = path.includes('?') ? '&' : '?'
  return `${path}${separator}${gtmString}`
}

export function useNavigateWithGTMParams(): NavigateFunction {
  const navigate = useNavigate()
  const { search } = useLocation()

  return useCallback<NavigateFunction>(
    (to: any, options?: any) => {
      if (typeof to === 'string') {
        return navigate(appendGTMParams(to, search), options)
      }
      return navigate(to, options)
    },
    [navigate, search],
  )
}
